<template>
	<div class="cookie-bar" v-if="!consent">
		<div>
			Ao utilizar o serviço do Facilimo, concorda com a nossa utilização de cookies.
			<router-link class="" :to="{name: 'privacy'}">(Saiba mais)</router-link>
		</div>
		<a class="button is-primary is-outlined button-pro" @click="doConsent()">
			OK
		</a>
	</div>
</template>

<script>
	export default {
		name: "CookieBar",
		data() {
			return {
				consent: false,
			}
		},
		created() {
			this.checkConsent();
		},
		methods: {
			doConsent() {
				localStorage.setItem("cookie-consent", true);
				this.consent = true;
			},
			checkConsent() {
				this.consent = localStorage.getItem("cookie-consent");
			}
		}
	}
</script>

<style scoped lang="scss">
	.button-pro {
		font-weight: 900;
		font-size: 0.8rem;
		//padding: 0.5rem 1rem;
		//border-width: 3px;
	}
	.cookie-bar{
		position: fixed;
		bottom: 0;
		width: 100%;
		//height: 60px;
		font-size: 14px;
		color: white;
		font-weight: 600;
		background: rgba(0,0,0,0.66);
		z-index: 5;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		padding: 0 8rem;
	}

	@media only screen and (max-width: 768px) {
		.cookie-bar{

			padding: 0 4rem 0 1rem;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/CookieBar.vue